var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg91(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65.42 43.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g{fill:#00322e;}.h{fill:#fff;filter:url(#b);}.i{filter:url(#e);}"), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "c",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "c",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "f",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "f",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M30.29,37.95c-7.44,0-12.25-3.59-12.87-9.59l-.2-1.9,5.26-.8c-2.33-1.83-3.71-4.71-3.71-8.19,0-7.46,5.53-12.28,14.08-12.28s13.32,5.04,13.32,13.48c0,12.07-5.94,19.28-15.88,19.28Zm1.44-20.08s.12,.04,.36,.04c.45,0,1.4,0,1.4-1.92,0-.29-.06-.43-.08-.45-.02-.01-.16-.07-.44-.07-.62,0-1.32,0-1.32,1.92,0,.33,.07,.46,.08,.48h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M44.17,18.67c0,10.04-4.32,17.28-13.88,17.28-6.36,0-10.36-2.76-10.88-7.8l9.16-1.4c.08,1.76,.72,2.84,2.28,2.84,2.12,0,3.56-2.08,4.12-6.4-1.4,1.84-3.28,2.64-5.8,2.64-5.2,0-8.4-3.48-8.4-8.36,0-6.32,4.6-10.28,12.08-10.28,7.88,0,11.32,4.92,11.32,11.48Zm-8.68-2.68c0-1.48-.8-2.52-2.52-2.52-2.4,0-3.32,1.64-3.32,3.92,0,1.52,.8,2.52,2.44,2.52,2.24,0,3.4-1.6,3.4-3.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg91);
export default __webpack_public_path__ + "static/media/9_1.5a63069559635400883eb0cb92b72026.svg";
export { ForwardRef as ReactComponent };